// extracted by mini-css-extract-plugin
module.exports = {"heading":"Confirmation_heading__1Hxfh","icon":"Confirmation_icon__2MnV-"};